// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__nx_v_","container":"styles_container__yF79X","error":"styles_error___Exod","inverted":"styles_inverted__5flF_"};